import { useEffect, useState } from "react";

const KEY = "theme";
const current = () => localStorage.getItem(KEY) || "light";

const apply = (t) => {
  document.documentElement.classList.toggle("light", t === "light");
  document.documentElement.classList.toggle("dark", t !== "light");
  document.querySelectorAll('meta[name="theme-color"]').forEach((m) => { m.content = t === "light" ? "#FFFFFF" : "#0B0D13"; });
  window.dispatchEvent(new Event("themechange"));
};

export const initTheme = () => apply(current());
export const setTheme = (t) => { localStorage.setItem(KEY, t); apply(t); };

export function useTheme() {
  const [theme, setT] = useState(current);
  useEffect(() => {
    const onChange = () => setT(current());
    window.addEventListener("themechange", onChange);
    return () => window.removeEventListener("themechange", onChange);
  }, []);
  return theme;
}
